import React from 'react';
import { Flex } from '@atlaskit/primitives';
import { TableColumns } from '@atlassian/jira-projects-directory-v3-utils/src/constants.tsx';
import type { actionsCell_projectsDirectoryV3_ActionsCellDropdown_jiraQueryRef$key } from '@atlassian/jira-relay/src/__generated__/actionsCell_projectsDirectoryV3_ActionsCellDropdown_jiraQueryRef.graphql';
import type { actionsCell_projectsDirectoryV3_project$key } from '@atlassian/jira-relay/src/__generated__/actionsCell_projectsDirectoryV3_project.graphql';
import type { favouriteCell_projectsDirectoryV3_FavoriteCell$key } from '@atlassian/jira-relay/src/__generated__/favouriteCell_projectsDirectoryV3_FavoriteCell.graphql';
import type { keyCell_projectsDirectoryV3$key } from '@atlassian/jira-relay/src/__generated__/keyCell_projectsDirectoryV3.graphql';
import type { lastIssueUpdateCell_projectsDirectoryV3$key } from '@atlassian/jira-relay/src/__generated__/lastIssueUpdateCell_projectsDirectoryV3.graphql';
import type { leadCell_projectsDirectoryV3$key } from '@atlassian/jira-relay/src/__generated__/leadCell_projectsDirectoryV3.graphql';
import type { nameCell_projectsDirectoryV3$key } from '@atlassian/jira-relay/src/__generated__/nameCell_projectsDirectoryV3.graphql';
import type { projectCategoryCell_projectsDirectoryV3$key } from '@atlassian/jira-relay/src/__generated__/projectCategoryCell_projectsDirectoryV3.graphql';
import type { projectTypeCell_projectsDirectoryV3$key } from '@atlassian/jira-relay/src/__generated__/projectTypeCell_projectsDirectoryV3.graphql';
import type { urlCell_projectsDirectoryV3$key } from '@atlassian/jira-relay/src/__generated__/urlCell_projectsDirectoryV3.graphql';
import { isVisualRefreshEnabled } from '@atlassian/jira-visual-refresh-rollout/src/feature-switch/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { ActionsCell } from './actions-cell/index.tsx';
import { FavoriteCell } from './favourite-cell/index.tsx';
import { KeyCell } from './key-cell/index.tsx';
import { LastIssueUpdateCell } from './last-issue-update-cell/index.tsx';
import { LeadCell } from './lead-cell/index.tsx';
import { NameCell } from './name-cell/index.tsx';
import { ProjectCategoryCell } from './project-category-cell/index.tsx';
import { ProjectTypeCell } from './project-type-cell/index.tsx';
import { UrlCell } from './url-cell/index.tsx';

export type projectRefType = favouriteCell_projectsDirectoryV3_FavoriteCell$key &
	keyCell_projectsDirectoryV3$key &
	nameCell_projectsDirectoryV3$key &
	projectTypeCell_projectsDirectoryV3$key &
	projectCategoryCell_projectsDirectoryV3$key &
	leadCell_projectsDirectoryV3$key &
	lastIssueUpdateCell_projectsDirectoryV3$key &
	urlCell_projectsDirectoryV3$key &
	actionsCell_projectsDirectoryV3_project$key;

export const getTableRow = (
	projectRef: projectRefType,
	isAdminSettingsContext: Boolean = false,
	jiraQueryRef: actionsCell_projectsDirectoryV3_ActionsCellDropdown_jiraQueryRef$key | null,
) => ({
	cells: [
		{
			key: TableColumns.Favourites,
			content: <FavoriteCell project={projectRef} />,
		},
		{
			key: TableColumns.Name,
			content: <NameCell project={projectRef} />,
		},
		{
			key: TableColumns.Key,
			content: <KeyCell project={projectRef} />,
		},
		{
			key: TableColumns.Type,
			content: <ProjectTypeCell project={projectRef} />,
		},
		{
			key: TableColumns.Lead,
			content: <LeadCell project={projectRef} />,
		},
		{
			key: TableColumns.Category,
			content: <ProjectCategoryCell project={projectRef} />,
		},
		...(isAdminSettingsContext
			? [
					{
						key: TableColumns.LastIssueUpdate,
						content: <LastIssueUpdateCell project={projectRef} />,
					},
				]
			: []),
		{
			key: TableColumns.Url,
			content:
				isVisualRefreshEnabled() && fg('visual-refresh-remove-more-actions-column') ? (
					<Flex alignItems="center">
						<UrlCell project={projectRef} />
						<ActionsCell project={projectRef} jiraQueryRef={jiraQueryRef} />
					</Flex>
				) : (
					<UrlCell project={projectRef} />
				),
		},
		...(!(isVisualRefreshEnabled() && fg('visual-refresh-remove-more-actions-column'))
			? [
					{
						key: TableColumns.Action,
						content: <ActionsCell project={projectRef} jiraQueryRef={jiraQueryRef} />,
					},
				]
			: []),
	],
});
